import React from 'react';
import { Card } from '../core/types';
import { Rules } from '../core/Rules';
import '../styles/CardComponent.css';

interface CardComponentProps {
  card?: Card | null;
  onClick?: () => void;
  selected?: boolean;
  animated?: boolean;
  isSmall?: boolean;
  isMicro?: boolean;
  isBack?: boolean; // 牌背 (背面朝上)
  disabled?: boolean;
  badge?: string; // 浮标标签，如 "摸", "进", "听"
  highlight?: boolean;
  hideWatermark?: boolean;
}

const CardComponent: React.FC<CardComponentProps> = ({
  card,
  onClick,
  selected = false,
  animated = false,
  isSmall = false,
  isMicro = false,
  isBack = false,
  disabled = false,
  badge,
  highlight = false,
  hideWatermark = false
}) => {
  if (isBack || !card) {
    return (
      <div className={`card card-back ${isMicro ? 'micro-size' : isSmall ? 'small-size' : ''} ${animated ? 'animated' : ''}`}>
        <div className="card-back-pattern">🎴</div>
      </div>
    );
  }

  const charName = card.name || Rules.getCardName(card.type, card.value);
  const cardClasses = [
    'card',
    card.type,
    card.isRed ? 'red' : 'black',
    selected ? 'selected' : '',
    animated ? 'animated' : '',
    isMicro ? 'micro-size' : isSmall ? 'small-size' : '',
    disabled ? 'disabled' : '',
    highlight ? 'highlight-glow' : ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cardClasses} onClick={!disabled ? onClick : undefined}>
      {badge && <span className="card-badge">{badge}</span>}
      {!hideWatermark && <span className="card-watermark">{card.type === 'big' ? '大' : '小'}</span>}
      <span className="card-char">{charName}</span>
      <span className="card-sub-num">{card.value}</span>
    </div>
  );
};

export default CardComponent;

